import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../Checkbox'

function SliceCheckbox(props, context) {
  const isChecked = props.slice.isSelected || props.isSelected
  const isOneWay = props.tripType === 'OW'

  return !isOneWay ? (
    <Checkbox
      onHover={props.onHover}
      anySlicesFilteredFor={context.anySlicesFilteredFor}
      hasNoHoverTooltipCookie={props.hasNoHoverTooltipCookie}
      isChecked={isChecked}
      checkAction={() => {
        if (!props.hasNoHoverTooltipCookie && !!props.setNoTooltipOnHoverCookie) {
          props.setNoTooltipOnHoverCookie()
        }
        context.onSliceFilter(props.slice, props.sliceIdForFilter, isChecked, props.tripType)
      }}
      isHovered={props.isHovered}
    />
  ) : null
}

SliceCheckbox.contextTypes = {
  SETI: PropTypes.object,
  anySlicesFilteredFor: PropTypes.bool,
  onSliceFilter: PropTypes.func,
}

SliceCheckbox.propTypes = {
  isSelected: PropTypes.bool,
  onHover: PropTypes.func.isRequired,
  slice: PropTypes.object.isRequired,
  tripType: PropTypes.string.isRequired,
  sliceIdForFilter: PropTypes.number.isRequired,
  hasNoHoverTooltipCookie: PropTypes.bool.isRequired,
  setNoTooltipOnHoverCookie: PropTypes.func.isRequired,
  isHovered: PropTypes.bool,
}

export default SliceCheckbox
